var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiSaleCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_1034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 15.867C17 16.847 16.2 17.647 15.22 17.647C14.24 17.647 13.45 16.847 13.45 15.867C13.45 14.887 14.24 14.097 15.22 14.097C16.2 14.097 17 14.887 17 15.867ZM8.83 11.247C9.81 11.247 10.6 10.457 10.6 9.47697C10.6 8.48697 9.81 7.69697 8.83 7.69697C7.84 7.69697 7.05 8.48697 7.05 9.47697C7.05 10.457 7.84 11.247 8.83 11.247ZM7 16.177L8.5 17.677L17.03 9.14697L15.53 7.64697L7 16.177ZM22 12.647C22 18.147 17.5 22.647 12 22.647C6.5 22.647 2 18.147 2 12.647C2 7.14697 6.5 2.64697 12 2.64697C17.5 2.64697 22 7.14697 22 12.647ZM20 12.647C20 8.23697 16.41 4.64697 12 4.64697C7.59 4.64697 4 8.23697 4 12.647C4 17.057 7.59 20.647 12 20.647C16.41 20.647 20 17.057 20 12.647Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_1034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.646973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiSaleCircleOutline);
export default __webpack_public_path__ + "static/media/mdi_sale-circle-outline.65f7fc03e3268e8445c106a8a7d270a0.svg";
export { ForwardRef as ReactComponent };